import React from "react";

const ShimmerWrapper = ({ length = 3, wrapperClass = "", cardClass = "", children }) => {
  const tempArr = Array(length)
    .fill()
    .map((_, i) => i + 1);
  return (
    <div className={wrapperClass}>
      {tempArr.map((elmt) => (
        <div key={`card-${elmt}`} className={cardClass}>
          {children}
        </div>
      ))}
    </div>
  );
};

export default ShimmerWrapper;
